module.exports = __webpack_public_path__ + "static/media/021-cloudy.428c7ca7.svg";